import PhotoReports from './photoReports'
export default PhotoReports
